var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTarget = function SvgTarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: 26,
    height: 26,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.8,25.8) scale(0.7,0.7)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.37981,-0.20673c-0.28426,0.05168 -0.56851,0.12921 -0.82692,0.20673c-3.07512,0.69772 -5.24579,3.46274 -5.16827,6.61538v7.02885c-34.83413,3.15265 -62.58774,30.88041 -65.74038,65.74038h-7.02885c-0.20673,0 -0.41346,0 -0.62019,0c-3.64363,0.18089 -6.48618,3.28185 -6.30529,6.92548c0.18089,3.64363 3.28185,6.48618 6.92548,6.30529h7.02885c3.15265,34.85997 30.90625,62.58774 65.74038,65.74038v7.02885c-0.02584,2.3774 1.21454,4.59976 3.28185,5.8143c2.06731,1.18871 4.59976,1.18871 6.66706,0c2.06731,-1.21454 3.30769,-3.4369 3.28185,-5.8143v-7.02885c34.83413,-3.15264 62.58774,-30.90625 65.74038,-65.74038h7.02885c2.3774,0.02584 4.59976,-1.21454 5.8143,-3.28185c1.18871,-2.06731 1.18871,-4.59976 0,-6.66706c-1.21454,-2.06731 -3.4369,-3.30769 -5.8143,-3.28185h-7.02885c-3.15264,-34.83413 -30.90625,-62.58774 -65.74038,-65.74038v-7.02885c0.07753,-1.91226 -0.69772,-3.74699 -2.06731,-5.03906c-1.39543,-1.31791 -3.28185,-1.96394 -5.16827,-1.78305zM92.61538,26.66827c27.72776,2.9976 49.71875,24.98858 52.71635,52.71635h-6.40865c-0.20673,0 -0.41346,0 -0.62019,0c-0.20673,0 -0.41346,0 -0.62019,0c-3.64363,0.33594 -6.33113,3.59195 -5.99519,7.23558c0.33594,3.64363 3.59195,6.33113 7.23558,5.99519h6.40865c-2.9976,27.72776 -24.98858,49.71875 -52.71635,52.71635v-6.40865c0.07753,-1.91226 -0.69772,-3.74699 -2.06731,-5.03906c-1.39543,-1.3179 -3.28185,-1.96394 -5.16827,-1.78305c-0.28426,0.05169 -0.56851,0.12921 -0.82692,0.20673c-3.07512,0.69772 -5.24579,3.46274 -5.16827,6.61538v6.20192c-27.72776,-3.02344 -49.71875,-24.78185 -52.71635,-52.50962h6.40865c2.3774,0.02584 4.59976,-1.21454 5.8143,-3.28185c1.18871,-2.06731 1.18871,-4.59976 0,-6.66706c-1.21454,-2.06731 -3.4369,-3.30769 -5.8143,-3.28185h-6.40865c2.9976,-27.72776 24.98858,-49.48618 52.71635,-52.50962v6.20192c-0.02584,2.3774 1.21454,4.59976 3.28185,5.8143c2.06731,1.18871 4.59976,1.18871 6.66706,0c2.06731,-1.21454 3.30769,-3.4369 3.28185,-5.8143zM86,59.53846c-14.6262,0 -26.46154,11.83534 -26.46154,26.46154c0,14.62621 11.83534,26.46154 26.46154,26.46154c14.62621,0 26.46154,-11.83533 26.46154,-26.46154c0,-14.6262 -11.83533,-26.46154 -26.46154,-26.46154z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/target.5b949a97.svg";
export { ForwardRef as ReactComponent };